import NumberField from '@/fields/NumberField';
import SelectField from '@/fields/SelectField';
import HtmlBuilder from '@/class/HtmlBuilder';
class NumblectField {
    constructor(label, options, value = '', min) {
        this._isSelect = false;
        this._label = label;
        this._input = NumberField.createElement(value, min);
        this._select = SelectField.createElement(value);
        this.changeOptions(options);
        this._block = HtmlBuilder.createBlock(label, this._input, this._select);
        this.initEvents();
    }
    get label() {
        return this._label;
    }
    get block() {
        return this._block;
    }
    get value() {
        return +(this._isSelect ? this._select.value : this._input.value);
    }
    set value(value) {
        this.setInputValue(String(value));
        this.setSelectValue(String(value));
    }
    nice(ev) {
        $(this._select).niceSelect(ev);
        if (!ev && !this._isSelect) {
            SelectField.findNiceElement(this._select).css({ display: 'none' });
        }
    }
    changeOptions(options) {
        this._select.innerHTML = '';
        this._select.append(...SelectField.changeOptions(options));
        $(this._select).niceSelect('update');
    }
    onChange(handler) {
        $(this._select).on('change', handler);
    }
    onBlur(handler) {
        $(this._input).on('blur', handler);
    }
    remove() {
        $(this._select).niceSelect('destroy');
        this.block.remove();
    }
    setSelectValue(value) {
        const options = SelectField.getOptions(this._select);
        if (!options.includes(value))
            return;
        this._select.value = value;
        this.nice('update');
        this.updateVisible();
        $(this._select).trigger('change');
    }
    setInputValue(value) {
        this._input.value = value;
    }
    updateVisible() {
        const niceSelect = SelectField.findNiceElement(this._select);
        if (this._isSelect) {
            $(this._input).css({ display: 'none' });
            niceSelect.css({ display: '' });
        }
        else {
            $(this._input).css({ display: '' });
            niceSelect.css({ display: 'none' });
        }
    }
    initEvents() {
        const $title = this.block.querySelector(`.${HtmlBuilder.labelClass}`);
        const $button = $title === null || $title === void 0 ? void 0 : $title.querySelector('button');
        const $toggle = $button || $title;
        $toggle && $($toggle).on('click', () => {
            this._isSelect = !this._isSelect;
            this.updateVisible();
        });
        $(this._input).on('blur', function () {
            NumberField.onBlurHandler.bind(this);
        });
        $(this._input).on('change', (e) => {
            this.setSelectValue(e.target.value);
        });
        $(this._select).on('change', (e) => {
            this.setInputValue(e.target.value);
        });
        $(() => this.updateVisible());
    }
}
export default NumblectField;
